import { Color } from "../enums/Color";

export const homePage = {
    mobile: {            
        wrapper: {                           
            margin: "20px 3% 0 3%",            
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center"
        },
        item: {
            width: "50%",
            boxSizing: "border-box", 
            marginTop: "70px",
            textAlign: "center"
        },
        pageTag: {
            textDecoration: "none"
        },
        icon: {
            height: "70px",
            width: "90px",
            marginBottom: "10px"
        },
        label: {
            color: Color.Green,            
            fontWeight: "bold",
            textAlign: "center"
        },
        slider: {                      
            display: "flex",
            flexDirection: "column" as "column",            
            margin: "50px 4% 0 4%",  
            overflow: "hidden",      
            contentWrapper: { },
            imageWrapper: {
                marginBottom: "1.21vw"
            },
            title: {                
                fontSize: "22px",
                fontWeight: "bold",
                color: Color.SharpAsh
            },
            content: {
                marginTop: "20px",
                fontSize: "16px",   
                lineHeight: "1.4",
                color: Color.SharpAsh
            },
            slider: {
                width: "98%",                
                border: "2px solid black",
                borderRadius: "20px",
                margin: "10px 1%"
            },
            slideLoader: {
                display: "flex",
                flexDirection: "column",            
                margin: "50px 4% 0 4%",  
                overflow: "hidden",      
                contentWrapper: { },
                imageWrapper: { }
            }
        },
        faqs: {
            wrapper: {
                display: "flex",
                flexDirection: "column",            
                margin: "12.07vw 4% 0 4%"
            },
            subTitle: {
                fontSize: "3.86vw",
                fontWeight: "bold",
                color: Color.PhilippineGray,
                margin: "0 0 2.41vw 0"
            },
            title: {
                width: "66.67vw",
                fontSize: "7.24vw",
                fontWeight: "bold",
                color: Color.DeepBlack,
                margin: "0 0 7.24vw 0"
            },
            titleGreen: {
                color: Color.MediumGreen
            },
            description: {
                fontSize: "3.62vw",
                color: Color.DarkLiver,
                margin: "0 0 7.24vw 0"
            },
            questionWrapper: {
                margin: "0 0 4.83vw 0"
            },
            question: {
                padding: "2.65vw 4.10vw",
                background: Color.DeepBlack,
                fontSize: "3.86vw",
                fontWeight: "bold",
                color: Color.White,
                borderRadius: "2.41vw 2.41vw 0 0"
            },
            answer: {
                padding: "4.83vw",
                background: Color.LightAsh,
                fontSize: "3.62vw",
                color: Color.DarkLiver,
                borderRadius: "0 0 2.41vw 2.41vw"
            }
        },
        banner: {
            margin: "50px 4% 0 4%"
        }
    },
    desktop: {           
        wrapper: { 
            margin: "20px 3% 0 3%"            
        },
        item: {
            width: "33%",            
            marginTop: "70px"            
        },      
        label: {            
            fontSize: "20px"
        },
        slider: {                      
            flexDirection: "row" as "row",
            margin: "100px 8%",
            toggleWrapper: {
                flexDirection: "row-reverse"
            },
            contentWrapper: {
                width: "35%",
                marginRight: "5%",
                toggle: {
                    marginRight: "unset",
                    marginLeft: "5%"
                }
            },
            imageWrapper: {
                width: "55%",
                marginLeft: "5%",
                marginBottom: "0.26vw",
                toggle: {
                    marginLeft: "unset",
                    marginRight: "5%"
                }
            },
            title: {
                marginTop: "10px",
                fontSize: "36px"
            },
            content: {
                marginTop: "30px",
                fontSize: "20px"
            },
            slider: {
                width: "96%",
                height: "640px",                
                borderRadius: "20px",
                margin: "10px 2%",                
                cursor: "pointer",            
                boxShadow: "0 3px 10px rgb(0 0 0 / 0.5)"                
            },
            slideLoader: {
                margin: "100px 8%",
                flexDirection: "row-reverse",
                contentWrapper: {
                    width: "35%",
                    marginLeft: "5%"
                },
                imageWrapper: {
                    width: "55%",
                    marginRight: "5%"                
                }
            }
        }, 
        faqs: {
            wrapper: {
                flexDirection: "row",            
                margin: "5.20vw 8%"
            },
            subTitle: {
                fontSize: "1.56vw",
                margin: "0 0 1.04vw 0"
            },
            title: {
                width: "19.42vw",
                fontSize: "2.86vw",
                margin: "0 6.30vw 2.60vw 0"
            },
            description: {
                width: "19.42vw",
                fontSize: "0.93vw",
                margin: "0"
            },
            questionWrapper: {
                margin: "0 0 1.04vw 0"
            },
            question: {
                padding: "1.25vw 1.56vw",
                fontSize: "1.04vw",
                borderRadius: "0.78vw 0.78vw 0 0"
            },
            answer: {
                padding: "1.82vw 5.31vw",
                fontSize: "0.93vw",
                borderRadius: "0 0 0.78vw 0.78vw"
            }
        },       
        banner: {
            margin: "0 8%"
        }
    }
}